import {Component, inject} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {DsBoxModule, DsButtonModule, DsFormFieldModule, DsHintModule, DsModalModule} from '@bmw-ds/components';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {IServerApi} from '@service-and-repairs/awpintegrationlib';
import {ServiceCase} from '../../../../core/service-case/models/service-case';
import {ServiceCaseManager} from '../../../../core/service-case/models/service-case-manager';
import {VehicleDataLoader} from '../../../../core/vehicle/services/vehicle-data.loader';
import {VehicleLoader} from '../../../../core/vehicle/services/vehicle.loader';
import {AwpClientLibService} from '../../../../services/awp-client-lib.service';

@Component({
  selector: 'app-service-case-add-vin-overlay',
  templateUrl: './service-case-add-vin-overlay.component.html',
  styleUrls: ['./service-case-add-vin-overlay.component.scss'],
  imports: [DsModalModule, DsBoxModule, DsFormFieldModule, DsHintModule, FormsModule, DsButtonModule, TranslateModule]
})
export class ServiceCaseAddVinOverlayComponent {
  private readonly serviceCaseManager: ServiceCaseManager = inject(ServiceCaseManager);
  private readonly vehicleLoader: VehicleLoader = inject(VehicleLoader);
  private readonly vehicleDataLoader: VehicleDataLoader = inject(VehicleDataLoader);
  private readonly translate: TranslateService = inject(TranslateService);
  private readonly awpClientLibService: AwpClientLibService = inject(AwpClientLibService);

  private readonly awpLib: IServerApi;

  visible: boolean = false;
  vin17Input: string = '';
  serviceCase: ServiceCase;

  constructor() {
    this.awpLib = this.awpClientLibService.serverApi;
  }

  show(serviceCase: ServiceCase): void {
    this.serviceCase = serviceCase;
    this.vin17Input = '';
    this.visible = true;
  }

  hide(): void {
    this.visible = false;
  }

  async confirm(): Promise<void> {
    if (this.vin17Input?.length !== 17) {
      return;
    }
    this.hide();
    this.serviceCaseManager.caseLoadingStarted.next();
    try {
      await this.vehicleLoader.loadVehicleByVin(this.vin17Input, this.serviceCase);
      await this.vehicleDataLoader.loadVehicleRelatedData(this.serviceCase);
    } catch {
      this.awpLib.notifyError(this.translate.instant('case.notificationVehicleLoadError'));
    }
    this.serviceCaseManager.caseLoadingFinished.next();
    this.serviceCaseManager.onServiceCaseUpdated(this.serviceCase, true, 'webapp');
  }
}
